import React from 'react';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { defineMessages, FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import TooltipMessage from '../../../components/shipment-status-icon/tooltip-message/index';
import TooltipError from '../../../components/shipment-status-icon/tooltip-error/index';

import style from '../shipment-status.module.less';

const messages = defineMessages({
  custEmail: {
    description: 'shipment-status.custEmail',
    defaultMessage: 'Cust. Email',
    id: 'QMmYrJ',
  },
  custEmailSent: {
    description: 'shipment-status.custEmailSent',
    defaultMessage: 'Customer Email Sent',
    id: 'RD41oj',
  },
  custEmailFailed: {
    description: 'shipment-status.custEmailFailed',
    defaultMessage: 'Customer Email Failed',
    id: 'CsXO8a',
  },
  sent: {
    description: 'shipment-status.sent',
    defaultMessage: 'Sent',
    id: 'D4NkPH',
  },
});

export default {
  id: 'return-email',
  generateProps: ({ returnEmailInformation }) => {
    const status = get(returnEmailInformation, 'status', '').toLowerCase();
    const errorMessage = get(returnEmailInformation, 'errorMessage');
    const date = get(returnEmailInformation, 'sentDateTime', '');
    const tooltipContent = errorMessage ? (
      <TooltipError content={errorMessage} title={<FormattedMessage {...messages.custEmailFailed} />} />
    ) : (
      <TooltipMessage date={date} singleMessage={messages.custEmailSent} />
    );

    return {
      title: <FormattedMessage {...messages.custEmail} />,
      icon: faPaperPlane,
      tooltipContent: status === 'notsent' ? null : tooltipContent,
      status: status === 'notsent' ? '' : status,
      message: status !== 'notsent' ? <FormattedMessage {...messages.sent} /> : undefined,
      clickable: false,
      key: 'return-email',
      iconStyle: style['plane-icon'],
    };
  },
};
